import CreateAndEditLanguageModal from "./create-and-edit-language-modal/create-and-edit-language-modal";

export { CreateAndEditLanguageModal }
export { LanguageTable } from "./language-table/language-table";